// appointments.js - simplified
import apiClient from './client';

// Base URL - adjust if your API has a different base URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

const appointmentsApi = {
  getCalendarTimezone: async () => (await apiClient.get('/appointments/calendar-timezone')).data,
  getCalendarAppointments: async (startDate, endDate, filters = {}, timeZone = null) => {
    try {
      // Convert array filters to comma-separated strings for API compatibility
      const apiFilters = { ...filters };
      if (apiFilters.user_ids && Array.isArray(apiFilters.user_ids)) {
        apiFilters.user_ids = apiFilters.user_ids.join(',');
      }
      if (apiFilters.location_ids && Array.isArray(apiFilters.location_ids)) {
        apiFilters.location_ids = apiFilters.location_ids.join(',');
      }

      const response = await apiClient.get('/appointments/calendar', {
        params: {
          start_date: startDate,
          end_date: endDate,
          ...apiFilters,
          ...(timeZone ? { calendar_timezone: timeZone } : {})
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching appointments:', error);
      throw error;
    }
  },



  // Fetch appointments with optional filters
  getAppointments: async (startDate, endDate, filters = {}) => {
    try {
      // Convert array filters to comma-separated strings for API compatibility
      const apiFilters = { ...filters };
      if (apiFilters.user_ids && Array.isArray(apiFilters.user_ids)) {
        apiFilters.user_ids = apiFilters.user_ids.join(',');
      }
      if (apiFilters.location_ids && Array.isArray(apiFilters.location_ids)) {
        apiFilters.location_ids = apiFilters.location_ids.join(',');
      }
      
      const response = await apiClient.get('/appointments', {
        params: {
          start_date: startDate,
          end_date: endDate,
          ...apiFilters
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching appointments:', error);
      throw error;
    }
  },
  
  // Get a single appointment by ID
  getAppointment: async (id) => {
    try {
      const response = await apiClient.get(`/appointments/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching appointment ${id}:`, error);
      throw error;
    }
  },
  
  // Create a new appointment
  createAppointment: async (appointmentData) => {
    try {
      const response = await apiClient.post(
        '/appointments', 
        appointmentData
      );
      return response.data;
    } catch (error) {
      console.error('Error creating appointment:', error);
      throw error;
    }
  },
  
  // Update an existing appointment
  updateAppointment: async (id, appointmentData) => {
    try {
      const response = await apiClient.put(
        `/appointments/${id}`, 
        appointmentData
      );
      return response.data;
    } catch (error) {
      console.error(`Error updating appointment ${id}:`, error);
      throw error;
    }
  },
  
  // Delete an appointment
  deleteAppointment: async (id) => {
    try {
      await apiClient.delete(`/appointments/${id}`);
      return true;
    } catch (error) {
      console.error(`Error deleting appointment ${id}:`, error);
      throw error;
    }
  },

  // New write endpoints with sync support
  createAppointmentWithSync: async (appointmentData) => {
    try {
      const response = await apiClient.post(
        '/appointments/create', 
        appointmentData
      );
      return response.data;
    } catch (error) {
      console.error('Error creating appointment with sync:', error);
      throw error;
    }
  },

  updateAppointmentWithSync: async (id, appointmentData) => {
    try {
      const response = await apiClient.put(
        `/appointments/${id}`, 
        appointmentData
      );
      return response.data;
    } catch (error) {
      console.error(`Error updating appointment ${id} with sync:`, error);
      throw error;
    }
  },

  cancelAppointmentWithSync: async (id, reason = null) => {
    try {
      const response = await apiClient.post(
        `/appointments/${id}/cancel`,
        { reason }
      );
      return response.data;
    } catch (error) {
      console.error(`Error cancelling appointment ${id}:`, error);
      throw error;
    }
  },

  getAppointmentSyncStatus: async (id) => {
    try {
      const response = await apiClient.get(`/appointments/${id}/sync-status`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching sync status for appointment ${id}:`, error);
      throw error;
    }
  },

  // Add to your existing appointments.js file
  getProviders: async () => {
    try {
      // Change to the correct endpoint in appointments router
      const response = await apiClient.get('/appointments/providers');
      console.log("Providers response:", response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching providers:', error);
      return []; // Return empty array as fallback
    }
  },

  getLocations: async () => {
    try {
      // Change to the correct endpoint in appointments router
      const response = await apiClient.get('/appointments/locations');
      console.log("Locations response:", response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching locations:', error);
      return []; // Return empty array as fallback
    }
  }
}

export default appointmentsApi;